<template>
  <div class="text-center py-5">
    <strong class="fa fa-3x fa-spin fa-spinner"/>
  </div>
</template>

<script>
	export default {
		name: 'LoadingSpinner'
	};
</script>
